module["exports"] = [
  "سيد",
  "سيدة",
  "آنسة",
  "دكتور",
  "بروفيسور"
];
